import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/site/motion";
import { THERAPIES } from "@/data/content";

const TherapiesMarquee = () => (
  <section className="bg-forest py-20 md:py-28 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 mb-12">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.25em] text-sage mb-4">Evidence-Based Programming</p>
        <h2 className="font-serif text-4xl md:text-6xl text-sand tracking-tight max-w-3xl leading-[1.02]">
          Proven therapies, delivered with genuine warmth
        </h2>
      </Reveal>
    </div>

    <Marquee speed={40} gradient={false} pauseOnHover>
      {THERAPIES.map((t) => (
        <span key={t} className="mx-6 flex items-center gap-6">
          <span className="font-serif text-3xl md:text-5xl text-sand/90 italic whitespace-nowrap">{t}</span>
          <span className="w-2 h-2 rounded-full bg-terracotta" />
        </span>
      ))}
    </Marquee>

    <div className="mx-auto max-w-[1400px] px-5 md:px-10 mt-12">
      <Reveal>
        <p className="text-sand/60 max-w-2xl leading-relaxed">
          Our biopsychosocial approach draws on CBT, DBT, SMART Recovery, mindfulness and the 12 steps —
          guided by counsellors, doctors, nutritionists and family therapists working as one team.
        </p>
      </Reveal>
    </div>
  </section>
);

export default TherapiesMarquee;
